import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {ReportCycleSearch} from '../../admin/models/report-cycle-search.interface';
import {HttpClient} from '@angular/common/http';
import {PageRequest} from '../../shared/models/page-request.interface';
import {Observable} from 'rxjs';
import {Page} from '../../shared/models/page.interface';
import {KFConfiguration} from '../../kf-data-entry/models/kf-configuration.interface';
import {ApiHttpResponse} from '../../shared/models/api-http-response.interface';
import {KfConfigMappings} from '../../kf-data-entry/models/kf-config-mapping.interface';

const KF_CONFIGURATION_API = environment.apiUrl + 'kfconfiguration/admin';

@Injectable({
  providedIn: 'root'
})
export class KfConfigurationAdminService {

  static getSortCode(sort: string): string {
    switch (sort) {
      default:
        return sort;
    }
  }

  static buildSearchParams(search: ReportCycleSearch): string {
    let searchParams = '';
    if (search.startYear && search.startYear !== '') {
      searchParams += `&startYear=${search.startYear}`;
    }
    if (search.endYear && search.endYear !== '') {
      searchParams += `&endYear=${search.endYear}`;
    }
    if (search.unuKeyName && search.unuKeyName !== '') {
      searchParams += `&unuKeyName=${search.unuKeyName}`;
    }
    if (search.entry && search.entry !== '') {
      searchParams += `&entry=${search.entry}`;
    }
    if (search.kfCategoryName && search.kfCategoryName !== '') {
      searchParams += `&kfCategoryName=${search.kfCategoryName}`;
    }
    if (search.collectionStreamName && search.collectionStreamName !== '') {
      searchParams += `&collectionStreamName=${search.collectionStreamName}`;
    }
    if (search.launched || search.launched === false) {
      searchParams += `&launched=${search.launched}`;
    }
    if (search.startLaunched && search.startLaunched !== '') {
      searchParams += `&startLaunched=${search.startLaunched}`;
    }
    if (search.endLaunched && search.endLaunched !== '') {
      searchParams += `&endLaunched=${search.endLaunched}`;
    }
    if (search.schemaKind && search.schemaKind !== '') {
      searchParams += `&schemaKind=${search.schemaKind}`;
    }
    if (search.open) {
      searchParams += `&open=${search.open}`;
    }
    return searchParams;
  }

  constructor(private http: HttpClient) {
  }

  getAll(pageRequest: PageRequest = {page: 0, size: 100}): Observable<Page<KFConfiguration>> {
    let url = `${KF_CONFIGURATION_API}?size=${pageRequest.size}&page=${pageRequest.page}`;
    if (pageRequest.sort && pageRequest.direction) {
      url = url + `&sort=${KfConfigurationAdminService.getSortCode(pageRequest.sort)},${pageRequest.direction}`;
    }
    return this.http.get<Page<KFConfiguration>>(url);
  }

  search(search: ReportCycleSearch, pageRequest: PageRequest): Observable<Page<KFConfiguration>> {
    let url = `${KF_CONFIGURATION_API}?size=${pageRequest.size}&page=${pageRequest.page}`;
    const searchParams = KfConfigurationAdminService.buildSearchParams(search);
    if (pageRequest.sort && pageRequest.direction) {
      url = url + `&sort=${KfConfigurationAdminService.getSortCode(pageRequest.sort)},${pageRequest.direction}`;
    }
    return this.http.get<Page<KFConfiguration>>(url + searchParams);
  }

  reopen(referenceId: string): Observable<any> {
    return this.http.get<ApiHttpResponse<KfConfigMappings>>
    (`${KF_CONFIGURATION_API}/reopen?referenceId=${referenceId}`);
  }

  printPdf(year: number, id: number, schemaKind: string): Observable<any> {
    return this.http.get(`${KF_CONFIGURATION_API}/print?year=${year}&id=${id}&schemaKind=${schemaKind}`, {
      observe: 'response',
      responseType: 'blob'
    });
  }
}
